var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"upload-field"},[_c('b-card',{staticClass:"mb-2",attrs:{"img-src":_vm.input,"img-top":""}},[_vm._t("default"),_vm._v(" "),_c('upload-field',{attrs:{"name":_vm.name,"label":_vm.label,"readonly":_vm.readonly,"value":_vm.input},on:{"input":_vm.handleInput}})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }